import React from 'react'
import { MenuItem as BsMenuItem } from 'react-bootstrap'

export function MenuItem({ fileref, filetype, title }) {
  const download_url = `/account/transcripts.download/${fileref}/${filetype}/${title}`
  const filetype_map = {'pdf': 'fa-file-pdf', 'txt': 'fa-text', 'doc': 'fa-file-word', 'docx': 'fa-file-word'}
  const filetype_icon = filetype_map[filetype]

  return <BsMenuItem href={download_url} className="transcript_download_item" aria-label={`Download transcript as ${filetype}`} download>
    <i className={`fal ${filetype_icon} mx-2`} aria-hidden="true"></i>
    <span className='px-2'>{filetype.toUpperCase()}</span>
    <i className={`fal fa-arrow-to-bottom mx-1 pull-right mt-1`}></i>
  </BsMenuItem >
}
